import { defineMessages } from 'react-intl';

export const maxChars = Object.freeze({
  DEFAULT: 45,
  NAME: 30,
  BIO: 1024,
} as const);

export const ERROR_KEY = 'userProfileErrors';
export const errorTypes = Object.freeze({
  invalidWebname: 'INVALID_WEBNAME',
  privateProfile: 'PRIVATE_PROFILE',
} as const);

export const dropdownMessages = defineMessages({
  createStation: {
    id: 't.createStation',
    defaultMessage: 'Start Station',
  },
  share: {
    id: 't.share',
    defaultMessage: 'Share',
  },
} as const);

export const messages = defineMessages({
  profile: {
    id: 't.profile',
    defaultMessage: 'profile',
  },
  location: {
    id: 't.location',
    defaultMessage: 'Hometown',
  },
  employer: {
    id: 't.employer',
    defaultMessage: 'Employer',
  },
  biography: {
    id: 't.biography',
    defaultMessage: 'Biography',
  },
  school: {
    id: 't.school',
    defaultMessage: 'School',
  },
  edit: {
    id: 't.edit',
    defaultMessage: 'Edit',
  },
  cancel: {
    id: 't.cancel',
    defaultMessage: 'Cancel',
  },
  save: {
    id: 't.save',
    defaultMessage: 'Save',
  },
  private: {
    id: 't.private',
    defaultMessage: 'private',
  },
  public: {
    id: 't.public',
    defaultMessage: 'public',
  },
  privateProfile: {
    id: 't.privateProfile',
    defaultMessage: 'private profile',
  },
  publicProfile: {
    id: 't.publicProfile',
    defaultMessage: 'public profile',
  },
  settings: {
    id: 't.settings',
    defaultMessage: 'Settings',
  },
  noBioPlaceholder: {
    id: 't.noBioPlaceholder',
    defaultMessage: 'This is your space to write something about yourself',
  },
  profilePrivacy: {
    id: 't.profilePrivacy',
    defaultMessage:
      'Your profile is currently {privacySetting}. To change your privacy preferences, go to',
  },
  thumbedUp: {
    id: 't.thumbedUp',
    defaultMessage: 'Thumbed Up',
  },
  stations: {
    id: 't.stations',
    defaultMessage: 'Stations',
  },
  albums: {
    id: 't.albums',
    defaultMessage: 'Albums',
  },
  tracks: {
    id: 't.tracks',
    defaultMessage: 'Tracks',
  },
  artists: {
    id: 't.artists',
    defaultMessage: 'Artists',
  },
  myProfile: {
    id: 't.myProfile',
    defaultMessage: 'My Profile',
  },
  thumbs: {
    id: 't.thumbs',
    defaultMessage: 'Thumbs Up',
  },
  thumbedUpOn: {
    id: 't.thumbedUpOn',
    defaultMessage: 'Thumbed on',
  },
  invalidWebnameError: {
    id: 't.invalidWebnameError',
    defaultMessage: 'Listener not found',
  },
  privateProfileError: {
    id: 't.privateProfileError',
    defaultMessage:
      'This profile has been marked "private" by the owner and may not be viewed. If this is your profile, you will need to sign in to access it',
  },
  seeAll: {
    id: 't.seeAll',
    defaultMessage: 'See All',
  },
} as const);

export const UserProfileActions = Object.freeze({
  RESET_ERROR_KEY: 'RESET_ERROR_KEY',
} as const);
